// Adds up to 2 zeroes after decimal if number has less than 2 digits after decimal
function addZeroes(val) {
  // Cast as number
  let num = Number(val)
  // If not a number, return 0
  if (isNaN(num)) {
    return 0
  }
  // If there is no decimal, or the decimal is less than 2 digits, toFixed
  if (
    String(num).split('.').length < 2 ||
    String(num).split('.')[1].length < 2
  ) {
    num = num.toFixed(2)
  }
  // Return the number
  return num
}

export { addZeroes }
